import linkStatusTransferScheduled from './link-status-transfer-scheduled.json';
import linkStatusTransferRequested from './link-status-transfer-requested.json';

export default {
  'link-status-moderate': {
    ...linkStatusTransferScheduled,
    ...linkStatusTransferRequested,
  },
};
